import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { SuperuserRolesCollection } from './superuser-roles.types';

export function superuserRolesBackend(): Backend<SuperuserRolesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: `superuser/0.1/superuser_roles`,
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
